import Cookies from 'js-cookie'
export default function AccessToken() {
  let ownerToken = Cookies.get('ownerToken');
  if (ownerToken) {

    return {token: ownerToken};
  } else {
    return {token: ''};
  }
}



// WEBPACK FOOTER //
// ./src/services/auth-central.js